/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const bulkFetchRequestSchema = z.object({
  customFieldIds: z.array(z.int()).nullish(),
  fields: z.array(z.string()).nullish(),
  ids: z.array(z.int()),
});
